module.exports = __webpack_public_path__ + "static/media/recipe_category_15.77ada8fa.png";